// extracted by mini-css-extract-plugin
export default {"card":"styles_card__q1XHp","header":"styles_header__9DwNx","header_line":"styles_header_line__FixtY","title":"styles_title__4holZ"};